export const paymentColumns = [];
export const stockColumns = (
  { withCode } = {
    withCode: true,
  }
) => {
  const columns = [
    {
      label: 'Kode Barang',
    },
    {
      label: 'Nama Barang',
    },
    {
      label: 'Stock',
      classes: 'text-right',
    },
    {
      label: 'Stock Ordered',
      classes: 'text-right',
    },
    {
      label: 'Stock Dikirim',
      classes: 'text-right',
    },
  ];
  withCode
    ? columns.push({
        label: 'Kode Gudang',
      })
    : null;
  return columns;
};

export const ScStockColumns = (
  { withAreaZeroPrice, withWarehouseCode, withGlobalStock, withBonusSummary, officeType } = {
    withAreaZeroPrice: false,
    withWarehouseCode: false,
    withGlobalStock: false,
    withBonusSummary: false,
    officeType: null
  }
) => {
  const columns = [
    {
      label: 'Kode Barang',
    },
    {
      label: 'Nama Barang',
    },
    withWarehouseCode && {
      label: 'Kode Gudang',
    },
    {
      label: 'P/N',
    },
    withAreaZeroPrice && {
      label: 'HS 0',
      classes: 'text-right',
    },
    {
      label: 'Stock di Gudang',
      classes: 'text-right',
    },
    {
      label: 'Stock Promo',
      classes: 'text-right',
    },
    {
      label: 'Jumlah di Order',
      classes: 'text-right',
    },
    {
      label: 'Jumlah Order Promo',
      classes: 'text-right',
    },
    {
      label: 'Stock Tersedia',
      classes: 'text-right',
    },
    {
      label: 'Stock Tersedia Promo',
      classes: 'text-right',
    },
    withGlobalStock && {
      label: officeType === 'stockist_center' ? 'Promo Pusat & KP' : 'Promo Global',
      classes: 'text-right',
    },
    withBonusSummary && {
      label: 'Reimbursement',
      classes: 'text-right',
    },
    withBonusSummary && {
      label: 'Susulan Promo',
      classes: 'text-right',
    },
  ].filter(Boolean);
  return columns;
};
